import { ActivityIndicator, View } from "react-native";

import { useTheme } from "@/theme/useTheme";

import { ProductHeader } from "./header/ProductHeader";
import { useScreenStyles } from "./screenStyles";

/** Neutral loading screen while the session restores: product header, no content (FR-012). */
export function LoadingScreen() {
  const styles = useScreenStyles();
  const theme = useTheme();
  return (
    <View style={styles.screen} testID="loading-screen">
      <ProductHeader />
      <View style={styles.body} role="main">
        <ActivityIndicator
          size="large"
          color={theme.color.primary}
          accessibilityLabel="Loading"
        />
      </View>
    </View>
  );
}
